import { useState, useEffect } from "react";
import axios from 'axios';

function useAppConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false)

  useEffect(() => {
    axios.get('/api/config')
      .then(res => {
        setConfig(res.data.result.videoAppUrl);
      })
      .catch(err => {
        console.error(err);
        setError(true);
      })
      .finally(() => {
        setLoading(false)
      });
  }, [])

  return { config, loading, error };
}

export default useAppConfig;